<template>
  <div id="my-padding" v-loading="loading">
    <div v-show="$route.name=='myStart'">
      <el-form label-width="120px" class="search-form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="流程编号">
              <el-input
                placeholder="请输入流程编号"
                v-model.trim="processNo"
                class="search-item-content"
                maxlength="20"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程类型">
              <el-select placeholder="请选择流程类型" v-model="applyType" clearable class="search-item-content">
                <el-option
                  v-for="item in typeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="流程标题">
              <el-input
                placeholder="请输入流程标题"
                v-model.trim="title"
                class="search-item-content"
                maxlength="20"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="流程日期">
              <el-date-picker
                v-model="applyDate"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="timestamp"
                class="search-item-content"
                clearable
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="申请人">
              <user-filter
                clearable
                v-model="applyId"
                class="search__item"
                @getStaffNo="getStaffNo"
              ></user-filter>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <!-- <el-form-item label="一级部门">
              <el-select
                clearable
                v-model="createrDept"
                filterable
                class="search-item-content"
                placeholder="请选择一级部门"
              >
                <el-option
                  v-for="item in primaryList"
                  :key="item.dicName"
                  :label="item.dicName"
                  :value="item.dicName"
                ></el-option>
              </el-select>
            </el-form-item> -->
          </el-col>
          <div style="float: right">
            <el-button type="primary" @click="queryInCondition">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </div>
          <div style="clear: both"></div>
        </el-row>
      </el-form>
      <common-table
        :data="tableData"
        :tableColumnData="tableColumnData"
      >
        <template slot="appliCode" slot-scope="{ scope }">
          <el-button type="text" size="mini" @click="solveItImmediately(scope.row)">{{
            scope.row.appliCode
          }}</el-button>
        </template>
        <template slot="operation" slot-scope="{ scope }">
          <el-button
            type="text"
            size="mini"
            @click="solveItImmediately(scope.row)"
            >查看</el-button
          >
        </template>
        <template slot="statusStr" slot-scope="{ scope }">
          <div v-if="scope.row.status == 1">
            <div class="dot looking"></div>
            <span>审批中</span>
          </div>
          <div v-if="scope.row.status == 2">
            <div class="dot back"></div>
            <span>已撤回</span>
          </div>
          <div v-if="scope.row.status == 3">
            <div class="dot pass"></div>
            <span>已通过</span>
          </div>
          <div v-if="scope.row.status == 4">
            <div class="dot danger"></div>
            <span>已拒绝</span>
          </div>
          <div v-if="scope.row.status == 5">
            <div class="dot cancel"></div>
            <span>已取消</span>
          </div>
        </template>
      </common-table>
      <el-pagination
        class="page-style"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <router-view v-if="$route.name!='myStart'" ></router-view>
  </div>
</template>

<script>
import { 
  queryMyStartList, // 查询代办列表
  queryApplyTypeList, // 获取所有流程类型
} from "../home-page-request.js";
import commonTable from "@/common/components/commonTable"; // 公共表格组件
import UserFilter from "library/components/UserFilter";
import { awaitWrapper } from "@/common/utils/assist.js"; //
import { tableColumnData } from './config'

export default {
  name: "myPedding",
  components: {
    commonTable, // 公共表格组件
    UserFilter
  },
  props: {
    // primaryList: Array, // 一级部门列表
  },
  data() {
    return {
      loading: false,
      isHome: true,
      typeList: [], // 流程类型下拉框内容
      typeObj: {},
      statusObj: {},
      // 搜索条件
      processNo: null, // 流程编号
      applyType: "", // 流程类型
      title: "", // 流程标题
      applyDate: "", // 流程日期
      // applyer: "", // 申请人
      createrDept: "", // 一级部门
      createrDeptName: "", 
      // applyId: "", // 申请人id
      applyCode: "", // 申请人code
      pickerOptions: {
        disabledDate(time) {
          let oneDay = 24 * 60 * 60 * 1000;
          return (
            time.getTime() >
            new Date(new Date().toLocaleDateString()).getTime() + oneDay - 1
          );
        },
      },
      // staffNo: null, // 工号
      // 下方表格相关数据
      tableData: [],
      tableColumnData: tableColumnData,
      // 分页信息
      currentPage: 1, // 当前页
      pageSize: 10, // 每页条数
      totalCount: 0, // 总条数
    };
  },
  watch: {
    $route(to, from) {
      if (to.name === "myPedding") {
        this.queryList(); // 获取我提交的表格数据
      }
    },
  },
  created() {
    this.queryApplyTypeList() // 获取流程类型
  },
  methods: {
    async queryApplyStatusList() { // 流程状态
      this.loading = true
      let res = await queryApplyStatusList();
      this.loading = false
      if( res && res.data) {
        this.statusObj = res.data || {}
        // for(let key in res.data) {
        //   this.statusList.push({
        //     id: key,
        //     name: res.data[key]
        //   })
        // }
      }
    },
    // setCreateDeptName() {
    //   if( this.createrDept ) {
    //     const checkedDeptList = this.primaryList.filter(item=>item.dicId ==this.createrDept)
    //     if( checkedDeptList.length > 0) {
    //       this.createrDeptName = checkedDeptList[0].dicName
    //     }
    //   }
    // },
    async queryApplyTypeList () { // 获取流程类型
      this.loading = true
      const [, res] = await awaitWrapper(queryApplyTypeList({}));
      this.loading = false
      if (res && res.data) {
        this.typeObj = res.data || {}
        for(let key in this.typeObj) {
          if(key.includes(',')) {
            const val = key.split(',')
            val.forEach(item=>{
              this.typeObj[item] = this.typeObj[key]
            })
          } 
          this.typeList.push({
            value: key,
            label: this.typeObj[key]
          })
        }
      } 
      this.queryList(); // 获取我提交的表格数据
    }, 
    /**
     * @description 获取我提交的表格数据
     * @author wangjiaqun 044033
     */
    async queryList() {
      const params = {
        appliCode: this.processNo, // 流程编号
        // appliTypeName: this.applyType,
        // appliTypeName: "预算编制",
        appliType: this.applyType,
        title: this.title,
        startAppliTime: this.applyDate ? this.applyDate[0] : "", // 开始时间
        endAppliTime: this.applyDate ? this.applyDate[1] : "", // 结束时间
        userCode: this.staffNo,
        // createrCode: this.staffNo,
        // createrDept: this.createrDept,
        // createrDept: this.createrDeptName,
        deptName: this.createrDept,
        applyReqType: 0,
        pageDto: {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        },
      };
      this.loading = true
      const [, res] = await awaitWrapper(queryMyStartList(params));
      this.loading = false
      if (res && res.data) {
        this.tableData = res.data;
        this.tableData.forEach((ele) => {
          ele.user = `${ele.originatorName}（${ele.staffNo}）`;
          ele.approveType = this.typeObj[ele.appliType];
          ele.statusStr = this.statusObj[ele.status];
        });
        this.totalCount = res.pageDto.count; // 分页信息赋值
      } else {
        this.tableData = [];
        this.totalCount = 0;
      }
      // this.tableData = [{}]
      this.$emit("changeStartCount", this.totalCount);
    },
    /**
     * @description 点击查询按钮 条件查询
     * @author wangjiaqun 044033
     */
    queryInCondition() {
      // this.pageSize = 10;
      this.currentPage = 1;
      this.queryList();
    },
    /**
     * @description 重置按钮
     * @author wangjiaqun 044033
     */
    reset() {
      this.processNo = "";
      this.applyType = "";
      this.title = "";
      this.applyDate = "";
      // this.applyer = "";
      // this.applyId = ""; // 
      // this.staffNo = ""; // 
      this.createrDept = ""; // 一级部门
      this.createrDeptName = ''

      this.currentPage = 1;
      this.queryList();
    },
    /**
     * @description 点击立即处理
     * @author wangjiaqun 044033
     * @param {Object} row 行数据
     */
    solveItImmediately(row) { // 处理跳转到具体页面
      let routeName = "yearBudgetAdjustDetailFromStart"
      if (row.appliType != 2) {
        routeName = new Date('2025-03-01 23:59:59').getTime() < row.createtime ? 'taskDetailByMonthFromStart' : 'halfYearTaskDetailFromStart'
      }
      this.$router.push({ // TODO row.approveTypeId查询结果是有问题的，先这么着吧
        // name: row.approveTypeId == 1 ? 'sumbitHalfYearTask' :"yearBudgetAdjustDetail",
        // name: row.appliType == 2 ? 'yearBudgetAdjustDetailFromStart' :"halfYearTaskDetailFromStart",
        name: routeName,
        query: {
          appliId: row.id,
          processId: row.processId,
          id:  row.id,
          // year: 
        }
      })
      return
    },
    // 分页的相关方法
    // 每页条数更改
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryList();
    },
    // 当前页码更改
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryList();
    },
  },
};
</script>

<style lang="scss" scoped>
/* /deep/.el-form-item--small .el-form-item__label {
  width: 100px !important;
}
/deep/.el-form-item--small .el-form-item__content {
  margin-left: 105px !important;
} */
.search-form {
  margin: 0 0 10px -15px;
}
.search-item-content {
  width: 100%;
}
.search-button {
  text-align: center;
}
.page-style {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 20px;
}
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 10px;
}
.looking {
  background: #1890ff;
}

.danger {
  background: #f5222d;
}

.pass {
  background: #52c41a;
}

.back {
  background: #fa541c;
}

.cancel {
  background: #fa541c;
}
</style>
